<template>
    <div class="salesforce-pattern">
        <IntegrationComponent
            ref="integration"
            :integration="integration"
            @integration-message="handleMessage"
            @integration-select-account="handleSelectAccount"
            @integration-activate="handleActivate"
            @integration-close="handleClose"
        >
            <template #icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54">
                    <g fill="none">
                        <path
                            fill="#009CDB"
                            d="M26.441 9.942l-.87.332a9.243 9.243 0 00-2.997 2.13 10.19 10.19 0 00-8.15-4.103c-5.669 0-10.265 4.655-10.265 10.413 0 1.469.295 2.873.84 4.135-2.74 1.63-4.42 4.618-4.412 7.842 0 5.004 3.943 9.057 8.82 9.057a8.646 8.646 0 001.815-.189c1.377 3.793 4.934 6.313 8.913 6.312 3.813-.001 7.256-2.319 8.743-5.886a8.077 8.077 0 003.65.853c3.016-.002 5.796-1.663 7.265-4.34.737.146 1.486.22 2.237.22 6.288 0 11.382-5.222 11.382-11.674 0-6.455-5.093-11.677-11.382-11.677-1.59.002-3.162.34-4.612.994-1.614-2.936-4.659-4.908-8.152-4.908a8.52 8.52 0 00-1.91.205l-.916.284"
                        />
                        <path
                            fill="#FFF"
                            d="M8.242 27.883l.032.03.293.192a3.274 3.274 0 001.585.379c1.087 0 1.755-.587 1.755-1.53v-.018c0-.867-.76-1.183-1.476-1.42l-.093-.032c-.543-.173-.993-.33-.993-.694v-.016c0-.315.263-.537.699-.537.466 0 1.025.159 1.382.364 0 0 .108.064.14-.031l.217-.6c.015-.063-.016-.095-.047-.127a3.042 3.042 0 00-1.552-.425h-.11c-.994 0-1.677.614-1.677 1.483v.015c0 .915.762 1.216 1.476 1.42l.11.031c.527.159.977.3.977.68v.015c0 .348-.295.6-.76.6h-.203l-.326-.047a2.551 2.551 0 01-.869-.363l-.188-.11c-.03-.017-.108-.05-.139.047l-.218.6-.015.094m15.854 0l.03.03.296.192c.404.22.792.314 1.182.361l.386.018.388-.033c.854-.127 1.367-.679 1.367-1.499v-.017c0-.866-.76-1.182-1.475-1.419l-.094-.032c-.542-.173-.993-.33-.993-.694v-.016c0-.315.264-.537.7-.537.464 0 1.024.159 1.381.364 0 0 .108.064.14-.031l.217-.6c.015-.063-.015-.095-.047-.127a3.042 3.042 0 00-1.552-.425h-.11c-.994 0-1.677.614-1.677 1.483v.015c0 .915.762 1.216 1.476 1.42l.11.031c.527.159.977.3.977.68v.015c0 .348-.295.6-.76.6-.187 0-.761 0-1.397-.41l-.188-.11c-.015-.017-.108-.05-.139.047l-.219.6v.094m9.939-3.582l.233.079c.147.074.27.19.358.331.186.3.294.71.294 1.248 0 .535-.094.946-.295 1.246-.186.3-.481.44-.884.44-.404 0-.685-.139-.87-.44-.187-.3-.28-.726-.28-1.247 0-.537.094-.946.28-1.248.185-.283.48-.424.869-.424l.295.015m-.28-.867l-.511.046-.451.144a1.994 1.994 0 00-1.102 1.34 3.31 3.31 0 00-.141.994c0 .347.047.68.14.994.095.298.233.568.42.805.186.22.419.41.698.537.28.126.606.19.963.19s.698-.065.963-.191c.274-.118.514-.303.7-.536.186-.221.324-.49.402-.804.097-.322.145-.658.141-.995a3.47 3.47 0 00-.141-.995 2.784 2.784 0 00-.403-.804c-.19-.23-.43-.413-.7-.537l-.449-.14-.528-.048m7.81.046l-.465.144c-.28.123-.53.306-.73.536a2.218 2.218 0 00-.434.803 3.31 3.31 0 00-.142.995c0 .758.203 1.372.606 1.83.404.457 1.01.678 1.786.678a3.46 3.46 0 001.274-.236s.061-.031.031-.111l-.218-.63c-.031-.096-.108-.064-.108-.064l-.42.127-.497.031c-.434 0-.79-.126-1.04-.394-.248-.269-.389-.68-.389-1.262 0-.521.125-.915.342-1.216.219-.3.56-.441 1.01-.441.372 0 .651.047.962.141 0 0 .078.032.109-.062l.217-.633c.032-.062-.03-.093-.062-.11l-.264-.078-.34-.08-.684-.046-.544.08m6.445 2.224l-.016-.427a3.109 3.109 0 00-.093-.505 1.834 1.834 0 00-.388-.725c-.202-.22-.389-.365-.575-.441l-.404-.127-.465-.047-.544.046-.249.063-.217.096c-.27.13-.51.318-.7.552-.19.238-.333.511-.419.804a3.42 3.42 0 00-.14.995c0 .363.048.694.142.994.093.299.246.568.45.788.202.222.465.395.76.522.31.126.684.19 1.118.19.885 0 1.351-.205 1.538-.317.03-.016.062-.047.03-.141l-.203-.568c-.03-.08-.107-.049-.107-.049-.217.08-.528.238-1.258.238-.482 0-.822-.144-1.04-.363-.233-.222-.341-.57-.357-1.043h3.059s.078 0 .093-.077l-.015-.458m-3.169-.268l.094-.41c.04-.116.091-.228.155-.333.186-.284.466-.458.869-.458.405 0 .67.159.854.458l.078.159.062.174.062.393h-2.174m-24.518.017l.094-.41c.046-.128.093-.238.154-.333.186-.284.467-.458.87-.458.403 0 .668.159.854.458l.077.159.062.174.063.393h-2.174m.652-1.94l-.248.062c-.078.032-.156.048-.218.096-.27.13-.509.318-.698.552a2.32 2.32 0 00-.42.804 3.393 3.393 0 00-.14.995c0 .363.047.694.14.994.094.299.25.568.45.788.203.222.466.395.777.522.31.126.683.19 1.117.19.886 0 1.35-.205 1.539-.317.03-.016.06-.047.03-.141l-.202-.568c-.031-.08-.11-.049-.11-.049-.216.08-.527.238-1.256.238-.481 0-.823-.144-1.04-.363-.233-.222-.342-.57-.358-1.043h3.059s.078 0 .093-.077c0-.032.109-.648-.092-1.341a1.834 1.834 0 00-.388-.726c-.202-.222-.389-.363-.576-.442l-.403-.127-.466-.048h-.59m-6.382 2.589l.575.03.248.033v1.419s-.388.079-.822.112c-.622.03-.901-.19-.901-.19-.125-.095-.14-.127-.172-.19a.762.762 0 01-.093-.41c0-.268.093-.473.28-.6 0 0 .156-.126.48-.189l.405-.015m-.529-.758l-.37.079a2.16 2.16 0 00-.638.299 1.497 1.497 0 00-.621 1.231c0 .269.047.522.14.71.093.19.232.365.404.49a1.5 1.5 0 00.62.268c.248.063.513.078.807.078.312-.002.624-.029.933-.078l.775-.158.218-.048c.078-.015.063-.095.063-.095v-2.84c0-.63-.172-1.089-.48-1.371-.327-.285-.794-.427-1.416-.427a4.76 4.76 0 00-.822.079s-.668.127-.947.347c0 0-.062.032-.032.126l.22.6c.029.08.092.048.092.048l.047-.032c.59-.331 1.334-.316 1.334-.316.326 0 .59.063.76.204.172.128.25.333.25.743v.126l-.497-.063-.481-.015-.359.015m23.914-1.53l-.233.22v-.377c0-.049-.03-.096-.093-.096h-.791c-.047 0-.094.046-.094.096v4.636c0 .049.048.097.095.097h.807c.046 0 .093-.048.093-.096v-2.32c0-.316.031-.614.093-.82.053-.17.143-.328.264-.457a.945.945 0 01.373-.238 1.34 1.34 0 01.404-.063c.155 0 .34.047.34.047.063 0 .094-.031.11-.078l.233-.648c.015-.061-.03-.11-.047-.11a3.06 3.06 0 00-.512-.095h-.264l-.203.032-.326.11-.247.16"
                        />
                        <path
                            fill="#FFF"
                            d="M29.44 23.322l-.033.205h-.699s-.077 0-.11.097l-.107.646c0 .063.015.095.093.095h.683l-.683 3.896a3.698 3.698 0 01-.187.775c-.05.157-.123.306-.217.441a.653.653 0 01-.28.22c-.116.033-.236.05-.356.048l-.25-.031-.17-.065s-.077-.03-.11.048l-.23.633c-.016.062.014.11.046.125l.279.079c.17.046.31.046.45.046.279 0 .543-.046.745-.125.216-.083.408-.218.559-.394.186-.206.295-.412.404-.696.125-.336.214-.685.264-1.04l.684-3.962h1.01s.076 0 .107-.095l.109-.644c0-.064-.016-.096-.094-.096h-.978c0-.016.047-.378.156-.694a.873.873 0 01.217-.332.568.568 0 01.265-.158l.325-.047.249.032.155.03c.093.033.11 0 .14-.046l.233-.647c.03-.064-.032-.094-.063-.11l-.31-.078-.419-.033c-.558 0-.993.157-1.29.474l-.216.268-.17.332-.142.378-.06.425m-11.04-1.688a.093.093 0 00-.096-.095h-.806c-.047 0-.093.048-.093.095v6.644c0 .047.031.093.093.093h.808c.047 0 .093-.047.093-.095v-6.642"
                        />
                    </g>
                </svg>
            </template>
            <template #configure>
                <div class="salesforce-pattern__step">
                    <transition-group name="slide-in-out" tag="div">
                        <div
                            v-if="activeConfigureStep === 0"
                            class="salesforce-pattern__step__inner"
                        >
                            <template v-if="hasSurveyEmail">
                                <h2>Choose a question containing respondents email</h2>
                                <p>Which question should we take the email from?</p>
                                <RowComponent justify="center">
                                    <SelectComponent
                                        :options="surveyEmails"
                                        placeholder="Choose email question..."
                                        @select="handleSelectEmail"
                                    />
                                </RowComponent>
                            </template>
                            <template v-else>
                                <h2>Your survey does not contain an email question!</h2>
                                <p>Please add an email question to proceed with the setup.</p>
                            </template>
                        </div>
                        <div
                            v-if="activeConfigureStep === 1"
                            class="salesforce-pattern__step__inner--map"
                        >
                            <template v-if="hasSurveyName">
                                <h2>Choose a question and map it to a Salesforce field.</h2>
                                <p>Which questions should we send answers from to Salesforce?</p>
                                <RowComponent align="center">
                                    <SelectComponent :selected="emailName" disabled />
                                    <DividerComponent />
                                    <SelectComponent selected="Email" disabled />
                                </RowComponent>
                                <RowComponent align="center">
                                    <SelectComponent
                                        :options="surveyNames"
                                        placeholder="Choose a question..."
                                        @select="handleSelectFromName"
                                    />
                                    <DividerComponent />
                                    <SelectComponent
                                        :options="[{ label: 'Name', value: 'name' }]"
                                        placeholder="Choose a field..."
                                        @select="handleSelectToName"
                                    />
                                </RowComponent>
                                <RowComponent justify="center">
                                    <ButtonComponent
                                        class="button-component--icon"
                                        shadow
                                        :disabled="continueDisabled"
                                        @click="handleContinue"
                                    >
                                        <i
                                            class="button-component__icon button-component__icon--arrow-right"
                                        />
                                        <span>Continue</span>
                                    </ButtonComponent>
                                </RowComponent>
                            </template>
                            <template v-else>
                                <h2>Your survey does not contain a name question!</h2>
                                <p>Please add a name question to proceed with the setup.</p>
                            </template>
                        </div>
                    </transition-group>
                </div>
            </template>
        </IntegrationComponent>
    </div>
</template>

<script>
import SurveyService from '@/services/survey-service'

export default {
    name: 'SalesforcePattern',

    data() {
        return {
            integration: {
                name: 'Salesforce',
                description:
                    'Generate leads from respondents’ entries, and let the list grow over time.'
            },
            integrationId: '',
            activeConfigureStep: 0,
            surveyItems: [],
            emailId: '',
            emailName: '',
            fromNameId: '',
            fromNameName: '',
            toNameId: '',
            toNameName: ''
        }
    },

    computed: {
        slug() {
            return this.integration.name
                .toLowerCase()
                .trim()
                .replace(/[\s\W-]+/g, '-')
        },

        surveyEmails() {
            const emails = []
            const typeArray = ['emailBox']

            this.surveyItems.forEach((item) => {
                if (typeArray.includes(item.itemType)) {
                    emails.push({
                        label: item.question.replace(/(<([^>]+)>)/gi, ''),
                        value: item.itemId
                    })
                }
            })

            return emails
        },

        surveyNames() {
            const names = []
            const typeArray = ['nameBox', 'textBox', 'paragraphBox']

            this.surveyItems.forEach((item) => {
                if (typeArray.includes(item.itemType)) {
                    names.push({
                        label: item.question.replace(/(<([^>]+)>)/gi, ''),
                        value: item.itemId
                    })
                }
            })

            return names
        },

        hasSurveyEmail() {
            return this.surveyEmails.length
        },

        hasSurveyName() {
            return this.surveyNames.length
        },

        continueDisabled() {
            return !this.fromNameId || !this.toNameId
        }
    },

    methods: {
        async handleMessage(data) {
            const { id } = await this.$store.dispatch('integrations/addAccount', {
                type: 'salesforce',
                email: data.email,
                access_token: data.access_token,
                refresh_token: data.refresh_token,
                scope: data.scope,
                api_endpoint: data.instance_url
            })

            this.integrationId = id
            this.fetchSurveyItems()

            this.$refs.integration.next()
        },

        handleSelectAccount(id) {
            this.integrationId = id
            this.fetchSurveyItems()

            this.$refs.integration.next()
        },

        async fetchSurveyItems() {
            const { data } = await SurveyService.fetchSurveyItems({
                id: this.$route.params.id
            })

            this.surveyItems = data
        },

        handleSelectEmail({ label, value }) {
            this.emailId = value
            this.emailName = label

            this.next()
        },

        handleSelectFromName({ label, value }) {
            this.fromNameId = value
            this.fromNameName = label
        },

        handleSelectToName({ label, value }) {
            this.toNameId = value
            this.toNameName = label
        },

        handleContinue() {
            this.$refs.integration.next()
        },

        async handleActivate() {
            await this.$store.dispatch('integrations/addIntegration', {
                type: this.slug,
                survey_id: this.$route.params.id,
                data: {
                    integration_id: this.integrationId,
                    settings: {
                        contact_map: {
                            email_id: this.emailId,
                            name_id: this.fromNameId
                        }
                    }
                }
            })

            this.$refs.integration.next()

            setTimeout(() => {
                this.$refs.integration.close()
            }, 400)
        },

        handleClose() {
            Object.assign(this.$data, this.$options.data.apply(this))
        },

        next() {
            this.activeConfigureStep++
        }
    }
}
</script>

<style scoped lang="scss">
.salesforce-pattern {
}

.salesforce-pattern__step {
    display: flex;

    flex-direction: column;
    justify-content: center;
    align-items: center;

    position: relative;

    width: 100%;

    .button-component__icon--arrow-right {
        @include icon('~@/assets/svg/icons/arrow-right.svg');
    }
}

.salesforce-pattern__step__inner {
    display: flex;

    flex-direction: column;
    justify-content: center;
    align-items: center;

    position: absolute;

    width: 100%;

    padding: 0 160px;

    will-change: transform;

    .row-component {
        margin-top: 50px;
    }
}

.salesforce-pattern__step__inner--map {
    .row-component {
        margin-top: 0;
    }

    p {
        margin-bottom: 40px;
    }

    .divider-component {
        width: 30px;
    }

    .row-component:last-child {
        margin-top: 40px;
    }
}
</style>
